import { memo } from 'react';
import { useSelector } from 'react-redux';
import FontAwesomeIcon from '../../../../../../../common/font-awesome-icon/font-awesome-icon';
import { ReactComponent as IconProfile } from '../../../../../../../images/user-icon.svg';
import translation from '../../../../../../../languages';
import cn from '../../../../../../../utils/classnames';
import schoolAccount from '../../../../../../../utils/school-account';

const SchoolAvatar = memo(() => {
    return (
        <div className='school-avatar d-flex justify-content-center align-items-center'>
            <FontAwesomeIcon height={20} width={20} name='school' theme='white' />
        </div>
    );
});
const TriggerAs = ({ user, t }: TranslationProps & { user: User }) => {
    const { waiting_users_count = 0 } = schoolAccount.getData(user) as SchoolAccount;
    const empty = !user.details.unpaidInvoiceOrdersCount && !user.details.needsSellerInfo && !waiting_users_count;
    const isSchoolMaster = schoolAccount.isAdmin(user);
    const isActiveNavigationAbTest = useSelector(
        (state: RootState) => state.main.schoolClassification.isActiveNavigationAbTest
    );

    const amount =
        Number(user.details.unpaidInvoiceOrdersCount) +
        Number(user.details.needsSellerInfo) +
        Number(waiting_users_count);

    return (
        <div className='align-items-center d-flex flex-column justify-content-between header-user-btn'>
            <div
                aria-label='User Icon - Image Holder'
                className={cn('img-holder d-flex align-items-start justify-content-center position-relative', {
                    authorized: user.id,
                    empty,
                    master: isSchoolMaster
                })}
                data-amount={amount || 0}
                role='img'
                style={{ backgroundImage: isSchoolMaster ? undefined : `url(${user.userImagePath})` }}
            >
                {!user.userImagePath && !isSchoolMaster && <IconProfile />}
                {isSchoolMaster && <SchoolAvatar />}
            </div>
            <div className='text-holder d-none d-lg-block text-center'>
                {!user.userName && (
                    <div className={cn({ 'tsc-caption': isActiveNavigationAbTest })}>{t('header.icons.login')}</div>
                )}
                {user.loggedInAsAnotherUser && (
                    <div className={cn('ellipsis user-name', { 'tsc-caption': isActiveNavigationAbTest })}>
                        {user.userName}
                    </div>
                )}
                {user.userName && !user.loggedInAsAnotherUser && (
                    <div className={cn('ellipsis user-name', { 'tsc-caption': isActiveNavigationAbTest })}>
                        {t('header.userMenu.main')}
                    </div>
                )}
            </div>
        </div>
    );
};

const translate = translation('header');

export default translate(memo(TriggerAs));
